import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

export default function DeprecatedConfigureBidRules() {
  const navigate = useNavigate();
  const dashboardSideBarVisibiltyState = useSelector(
    (state) => state.dashboardData.dashboardSideBarVisibiltyState
  );

  return (
    <div
      className={
        dashboardSideBarVisibiltyState
          ? "main-content-container-onopen-mode"
          : "main-content-container-oncolapse-mode"
      }
      id="main-box"
    >
      <Box
        sx={{
          minHeight: "calc(100vh - 86px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          py: 4,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 640,
            p: { xs: 3, md: 4 },
            borderRadius: 3,
            bgcolor: "#fff",
            border: "1px solid #E2E4E9",
            boxShadow: "0 8px 24px rgba(28, 28, 30, 0.06)",
          }}
        >
          <Typography
            sx={{
              display: "inline-block",
              mb: 1.5,
              px: 1.25,
              py: 0.35,
              borderRadius: 10,
              fontSize: "0.75rem",
              fontWeight: 700,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              color: "#9A3412",
              bgcolor: "rgba(234, 88, 12, 0.12)",
            }}
          >
            Deprecated
          </Typography>
          <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, color: "#1C1C1E", lineHeight: 1.3 }}>
            Configure Bid Rules has moved to Bid Automation
          </Typography>
          <Typography sx={{ mt: 1.5, fontSize: "0.975rem", color: "#334155", lineHeight: 1.7 }}>
            We have deprecated this old Configure Bid Rules page. Please go to Bid Automation and
            create your rules from there. It includes many new features.
          </Typography>
          <Typography sx={{ mt: 1.5, fontSize: "0.975rem", color: "#334155", lineHeight: 1.7 }}>
            Please move all existing bid automations to the new Bid Automation for better
            customization.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/bid-automation-list")}
            sx={{ mt: 3, px: 2.5, py: 1.1, fontWeight: 700, textTransform: "none", boxShadow: "none" }}
          >
            Go to Bid Automation
          </Button>
        </Box>
      </Box>
    </div>
  );
}
